var ProductComplianceLabelTypeEnum;
(function (ProductComplianceLabelTypeEnum) {
    ProductComplianceLabelTypeEnum["chileEnergyCompliance"] = "ENERGY_LABEL_CL";
    ProductComplianceLabelTypeEnum["chileSecLabel"] = "SEC_LABEL_CL";
    ProductComplianceLabelTypeEnum["usEnergy"] = "ENERGY_LABEL_US";
    ProductComplianceLabelTypeEnum["euEnergy"] = "ENERGY_LABEL_EU";
    ProductComplianceLabelTypeEnum["euUnifiedWaterLabel"] = "WATER_LABEL_EU";
    ProductComplianceLabelTypeEnum["repairabilityIndexDocument"] = "REPAIR_DOC_FR";
    ProductComplianceLabelTypeEnum["repairabilityIndexImage"] = "REPAIR_INDEX_FR";
})(ProductComplianceLabelTypeEnum || (ProductComplianceLabelTypeEnum = {}));
export default ProductComplianceLabelTypeEnum;
//# sourceMappingURL=ProductComplianceLabelTypeEnum.js.map